import { mainCustomerPage } from 'stores/customer/helpers';

export const getNavigateToByContext = ({ customerId, pharmacyId }: { customerId?: string; pharmacyId?: string }) => {
	if (!customerId) return '/login?logout=gnc';

	if (!pharmacyId) return mainCustomerPage();

	return '/';
};
